import { Injectable } from '@angular/core';

import { keys } from '../../constants/constants';

@Injectable({ providedIn: 'root' })
export class StorageService {
  set<T>(key: string, value: T): void {
    this.setRaw(key, JSON.stringify(value));
  }

  get<T>(key: string): T | null {
    const raw = this.getRaw(key);
    if (raw === null) {
      return null;
    }

    try {
      return JSON.parse(raw) as T;
    } catch {
      return null;
    }
  }

  remove(key: string): void {
    try {
      sessionStorage.removeItem(key);
    } catch {
      // storage blocked in private mode
    }
  }

  clear(): void {
    Object.values(keys).forEach(key => this.remove(key));
  }

  setRaw(key: string, value: string): void {
    try {
      sessionStorage.setItem(key, value);
    } catch {
      // storage blocked or over quota
    }
  }

  getRaw(key: string): string | null {
    try {
      return sessionStorage.getItem(key);
    } catch {
      return null;
    }
  }
}
